import { FunctionComponent, useContext, useState } from 'react';

import { MainContainer } from '../../../layout/components/MainContainer';
import { IHistoryCardProvider } from '../../../interfaces/service/HistoryCardServiceManagerInterface';
import { HistoryCardContextSM } from '../../../serviceContextManager/historyCards/HistoryCardServiceManager';
import { TableHistoryCards } from './components/TableHistoryCard';
import { Filters } from './components/Filters';
import { ChartHistoryCards } from './components/ChartHistoryCard';

export const HistoryCard: FunctionComponent = () => {
  const serviceInvetory =
    useContext<IHistoryCardProvider>(HistoryCardContextSM);
  const [openRightMenu, setOpenRightMenu] = useState(false);

  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-row ">
        <div className="flex grow h-full relative flex-col content-center items-center overflow-x-auto justify-center p-4 ">
          <div className="flex w-full h-full relative flex-col gap-y-2">
            <div className="flex w-full h-44">
              <Filters {...serviceInvetory} />
            </div>
            <div className="h-full flex flex-col w-full overflow-y-auto relative bg-white rounded-md shadow-lg p-2  ">
              {!serviceInvetory.showChart ? (
                <TableHistoryCards {...serviceInvetory} />
              ) : (
                <ChartHistoryCards {...serviceInvetory} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const loading = false;

  return (
    <MainContainer
      openRightMenu={openRightMenu}
      setOpenRightMenu={setOpenRightMenu}
      loading={loading}
      rightMenuContent={<></>}>
      {renderContent()}
    </MainContainer>
  );
};
